<template>
    <div >
        <nav-top :transmitData="transmitData"></nav-top>
        <div @click="toggleBox" id="sign-content" v-bind:style="{ height: tableHeight  + 'px' }">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
    import NavTop from '@/views/NavTop.vue'
    import About from '@/views/About.vue'

    export default {
        name: 'home',
        data() {
            return {
                tableHeight: document.body.clientHeight - 80,
                screenHeight:window.innerHeight,
                transmitData:1
            }
        },
        created() {
        },
        mounted() {
            const that = this
            window.onresize = () => {
                return (() => {
                    window.screenHeight = window.innerHeight
                    this.screenHeight = window.screenHeight;
                })()
            }
        },
        watch: {
            screenHeight(val) {
                this.screenHeight = val
                this.tableHeight = this.screenHeight - 80
            }
        },
        methods:{
            toggleBox() {
              this.transmitData += 1
            },
        },
        components: {
            NavTop
        }
    }
</script>

<style lang="scss">
    #sign-content {
        background-color: $theme-color;
    }

    .sign-page-content {
        width: 1180px;
        margin: 0 auto;
        margin-top: 8px;
        overflow: auto;
    }
</style>
